import { useQuery } from '@apollo/client';
import previewSrc from '@fanconnect/neo-client/dist/show.html?url';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { LoadingPane } from '~/components/loading-pane';
import { StoppablePreview } from '~/components/preview';
import { useAppContext } from '~/contexts';
import { usePreviewControl } from '~/hooks/preview';
import { playlistPreviewProps } from '~/lib/preview';
import { PlaylistPreviewDocument } from '../queries/preview.generated';
import { Layout } from './components/layout';
import { PlaylistProvider } from './context';

export const PlaylistPreviewPage = () => {
  const { currentNetwork } = useAppContext();
  const params = useParams<{ playlistId: string; playlistFolderId: string }>();
  const playlistId = parseInt(params.playlistId ?? '');
  const playlistFolderId = Number(params.playlistFolderId);

  const { data, loading } = useQuery(PlaylistPreviewDocument, {
    variables: { networkId: currentNetwork.id, playlistId, playlistFolderId },
  });

  const playlist = data?.network?.playlist;
  const playlistFolder = data?.network?.playlistFolder;

  const previewProps = useMemo(() => playlistPreviewProps(playlist), [playlist]);

  const previewControl = usePreviewControl('PlaylistPreview');

  return (
    <LoadingPane in={loading}>
      {playlist && playlistFolder && (
        <PlaylistProvider playlist={playlist} playlistFolder={playlistFolder}>
          <Layout>
            <StoppablePreview previewControl={previewControl} src={previewSrc} {...previewProps} />
          </Layout>
        </PlaylistProvider>
      )}
    </LoadingPane>
  );
};
